// extracted by mini-css-extract-plugin
export default {"login":"dRvDGt8n","hasContentBg":"o8BA1_Hj"};